module.exports = __webpack_public_path__ + "static/media/image_7.9a1d22cd.png";